/* ==========================================================================
   SAC DE JOUR — storefront script (Shopify theme)
   Ajax cart + section rendering, variant picker, facets, predictive search,
   drawers, mega menu, welcome popup (-5%), FAQ search, account helpers.
   ========================================================================== */
(function(){
  'use strict';
  const SDJ = window.SDJ || {};
  const routes = SDJ.routes || {};
  const root = (routes.root || '/').replace(/\/?$/, '/');
  const $ = (s, r=document) => r.querySelector(s);
  const $$ = (s, r=document) => [...r.querySelectorAll(s)];
  const esc = t => String(t == null ? '' : t).replace(/[&<>"']/g, c => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]));
  const norm = t => (t || '').toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '');
  const store = {
    get(k, d){ try { const v = localStorage.getItem(k); return v === null ? d : JSON.parse(v); } catch(e){ return d; } },
    set(k, v){ try { localStorage.setItem(k, JSON.stringify(v)); } catch(e){} }
  };
  const icon = (id, vb) => '<svg class="icon"'+(vb ? ' viewBox="'+vb+'"' : '')+'><use href="#'+id+'"/></svg>';
  const sized = (src, w) => { if (!src) return ''; const u = src.startsWith('//') ? 'https:' + src : src; return u + (u.includes('?') ? '&' : '?') + 'width=' + w; };

  /* ---------- Money ---------- */
  function formatMoney(cents, format){
    format = format || SDJ.moneyFormat || '{{amount_with_comma_separator}}€';
    cents = Math.round(Number(cents) || 0);
    const fmt = (n, dec, th, dc) => { const s = (n / 100).toFixed(dec).split('.'); s[0] = s[0].replace(/\B(?=(\d{3})+(?!\d))/g, th); return s[1] ? s[0] + dc + s[1] : s[0]; };
    return format.replace(/\{\{\s*(\w+)\s*\}\}/, (_, k) => ({
      amount: fmt(cents, 2, ',', '.'), amount_no_decimals: fmt(cents, 0, ',', '.'),
      amount_with_comma_separator: fmt(cents, 2, '.', ','), amount_no_decimals_with_comma_separator: fmt(cents, 0, '.', ','),
      amount_with_space_separator: fmt(cents, 2, ' ', ','), amount_with_apostrophe_separator: fmt(cents, 2, "'", '.')
    }[k] || fmt(cents, 2, '.', ',')));
  }
  SDJ.formatMoney = formatMoney;
  /* shipping date: today + N days (optionally skipping weekends), French month names */
  const MONTHS = ['Janvier','Février','Mars','Avril','Mai','Juin','Juillet','Août','Septembre','Octobre','Novembre','Décembre'];
  function shipDate(days, skipWeekends){
    const d = new Date(); let added = 0, guard = 0;
    while (added < days && guard < 40){ d.setDate(d.getDate() + 1); guard++; const wd = d.getDay(); if (skipWeekends && (wd === 0 || wd === 6)) continue; added++; }
    return d.getDate() + ' ' + MONTHS[d.getMonth()] + ' ' + d.getFullYear();
  }

  /* ======================================================================
     HEADER PANELS — mega menus + search
     ====================================================================== */
  const scrim = $('#scrim');
  const search = $('#searchPanel'), searchBtn = $('#searchToggle');
  const sInput = $('#searchInput'), sBody = $('#searchBody');
  function closePanels(){
    $$('.mega.is-open, .search-panel.is-open').forEach(p => { p.classList.remove('is-open'); p.setAttribute('aria-hidden','true'); });
    $$('[data-mega-toggle], #searchToggle').forEach(b => b.setAttribute('aria-expanded','false'));
    scrim && scrim.classList.remove('is-open');
  }
  function togglePanel(panel, btn){
    if (!panel) return false;
    const wasOpen = panel.classList.contains('is-open');
    closePanels();
    if (wasOpen) return false;
    panel.classList.add('is-open'); panel.setAttribute('aria-hidden','false'); btn && btn.setAttribute('aria-expanded','true');
    scrim && scrim.classList.add('is-open');
    return true;
  }
  $$('[data-mega-toggle]').forEach(b => b.addEventListener('click', () => togglePanel(document.getElementById(b.getAttribute('aria-controls')), b)));
  searchBtn && searchBtn.addEventListener('click', () => { if (togglePanel(search, searchBtn)) { renderSearch(sInput.value); setTimeout(() => sInput.focus(), 80); } });
  $('#searchClose') && $('#searchClose').addEventListener('click', closePanels);
  scrim && scrim.addEventListener('click', closePanels);

  /* ---------- Predictive search (Shopify /search/suggest.json) ---------- */
  const POPULAR = (SDJ.popularSearches || []).filter(Boolean);
  let sTimer = null, sReq = 0;
  const searchUrl = q => (routes.search || '/search') + '?type=product&q=' + encodeURIComponent(q);
  const hl = (text, q) => { const i = norm(text).indexOf(norm(q)); return i < 0 || !q ? esc(text) : esc(text.slice(0,i)) + '<mark>' + esc(text.slice(i, i+q.length)) + '</mark>' + esc(text.slice(i+q.length)); };
  const chips = (label, list) => list.length ? '<div><p class="search-label">'+label+'</p><div class="chips">'+list.join('')+'</div></div>' : '';
  function renderSearch(raw){
    if (!sBody) return;
    const q = raw.trim();
    clearTimeout(sTimer);
    if (!q){
      sBody.innerHTML = chips('Recherches populaires', POPULAR.map(t => '<a class="chip" href="'+searchUrl(t)+'">'+esc(t)+'</a>')) + (sBody.dataset.defaultHtml || '');
      return;
    }
    if (!sBody.querySelector('.s-loading')) sBody.insertAdjacentHTML('afterbegin', '<div class="s-loading" style="grid-column:1/-1"></div>');
    const id = ++sReq;
    sTimer = setTimeout(async () => {
      try {
        const r = await fetch((routes.predictive_search || '/search/suggest') + '.json?q=' + encodeURIComponent(q) + '&resources[type]=product,collection,page&resources[limit]=6&resources[options][unavailable_products]=last', {headers:{Accept:'application/json'}});
        const d = (await r.json()).resources.results;
        if (id !== sReq) return;
        const prods = d.products || [], cols = (d.collections || []).concat(d.pages || []);
        const left = cols.length ? chips('Collections & pages', cols.slice(0,8).map(c => '<a class="chip" href="'+esc(c.url)+'">'+hl(c.title,q)+'</a>'))
                                 : chips('Recherches populaires', POPULAR.map(t => '<a class="chip" href="'+searchUrl(t)+'">'+esc(t)+'</a>'));
        const right = prods.length
          ? '<div><p class="search-label">Produits</p><div class="s-products">' + prods.slice(0,5).map(p => {
              const price = Math.round(parseFloat(p.price) * 100), cmp = Math.round(parseFloat(p.compare_at_price_max || 0) * 100);
              const img = p.featured_image && p.featured_image.url ? p.featured_image.url : p.image;
              return '<a class="s-product" href="'+esc(p.url)+'"><img src="'+esc(sized(img, 300))+'" alt="" loading="lazy"><span class="t">'+hl(p.title,q)+'</span><span class="p">'+formatMoney(price)+(cmp > price ? '<s>'+formatMoney(cmp)+'</s>' : '')+'</span></a>';
            }).join('') + '</div><p style="margin-top:1rem"><a class="s-all" href="'+searchUrl(q)+'">Voir tous les résultats pour « '+esc(q)+' » →</a></p></div>'
          : '<div><p class="s-empty">Aucun produit trouvé pour « '+esc(q)+' ».</p><p style="margin-top:.75rem"><a class="s-all" href="'+searchUrl(q)+'">Rechercher sur toute la boutique →</a></p></div>';
        sBody.innerHTML = left + right;
      } catch(e) {
        if (id === sReq) sBody.innerHTML = '<div><a class="s-all" href="'+searchUrl(q)+'">Rechercher « '+esc(q)+' » →</a></div>';
      }
    }, 220);
  }
  if (sBody) sBody.dataset.defaultHtml = sBody.innerHTML;
  sInput && sInput.addEventListener('input', e => renderSearch(e.target.value));

  /* ======================================================================
     DRAWERS
     ====================================================================== */
  const overlay = $('#overlay');
  let lastFocus = null;
  function openDrawer(id){
    if (id === 'cartDrawer' && document.querySelector('[data-cart-page]')) return; /* never on the cart page */
    const d = document.getElementById(id); if (!d) return;
    closeDrawers(true); closePanels();
    lastFocus = document.activeElement;
    d.classList.add('is-open'); d.setAttribute('aria-hidden','false');
    overlay && overlay.classList.add('is-open'); document.body.classList.add('is-locked');
    d.setAttribute('tabindex','-1');
    setTimeout(() => d.focus({preventScroll:true}), 60);
  }
  function closeDrawers(silent){
    const open = $$('.drawer.is-open');
    open.forEach(d => { d.classList.remove('is-open'); d.setAttribute('aria-hidden','true'); });
    overlay && overlay.classList.remove('is-open');
    if (!$('.promo.is-open')) document.body.classList.remove('is-locked');
    if (!silent && open.length && lastFocus) lastFocus.focus({preventScroll:true});
  }
  SDJ.openDrawer = openDrawer; SDJ.closeDrawers = closeDrawers;

  /* ======================================================================
     AJAX CART — re-renders the drawer (and cart page) via the Section Rendering API
     ====================================================================== */
  const cartPage = $('[data-cart-page]');
  const sectionsToRender = () => ['sdj-cart-drawer'].concat(cartPage ? [cartPage.dataset.sectionId] : []);
  function applySections(sections){
    if (!sections) return;
    const parse = html => new DOMParser().parseFromString(html, 'text/html');
    if (sections['sdj-cart-drawer']){
      const doc = parse(sections['sdj-cart-drawer']);
      const fresh = $('#cartDrawerContent', doc), cur = $('#cartDrawerContent');
      if (fresh && cur){
        /* smooth swap: keep scroll position, animate only lines that are new */
        const prev = new Set($$('[data-line]', cur).map(l => l.dataset.line));
        const oldBody = cur.querySelector('.drawer__body'), st = oldBody ? oldBody.scrollTop : 0;
        $$('[data-line]', fresh).forEach(l => { if (!prev.has(l.dataset.line) && prev.size) l.classList.add('is-new'); });
        cur.replaceWith(fresh);
        const nb = fresh.querySelector('.drawer__body'); if (nb) nb.scrollTop = st;
      }
      const count = fresh ? fresh.dataset.count : null;
      if (count != null) $$('.cart-count[data-cart-count]').forEach(el => { el.textContent = count; el.classList.add('bump'); setTimeout(() => el.classList.remove('bump'), 250); });
    }
    if (cartPage && sections[cartPage.dataset.sectionId]){
      const doc = parse(sections[cartPage.dataset.sectionId]);
      const fresh = $('#cartPageInner', doc), cur = $('#cartPageInner');
      if (fresh && cur) cur.replaceWith(fresh);
      initCartSticky();
    }
  }
  /* cart page: sticky checkout bar on mobile, hidden while the main button is visible */
  function initCartSticky(){
    const bar = $('[data-cart-sticky]'), main = $('[data-cart-main-checkout]');
    if (window.__sdjStickyIO) window.__sdjStickyIO.disconnect();
    if (!bar || !main || !('IntersectionObserver' in window)) return;
    window.__sdjStickyIO = new IntersectionObserver(([en]) => bar.classList.toggle('is-hidden', en.isIntersecting));
    window.__sdjStickyIO.observe(main);
  }
  async function cartPost(url, body, busyEl){
    if (busyEl) busyEl.classList.add('is-busy');
    try {
      const r = await fetch(url, {method:'POST', headers:{'Content-Type':'application/json', Accept:'application/json'}, body:JSON.stringify(Object.assign(body, {sections:sectionsToRender(), sections_url:location.pathname}))});
      const data = await r.json();
      if (!r.ok || data.status){ throw new Error(data.description || data.message || 'Erreur panier'); }
      applySections(data.sections);
      return data;
    } finally { if (busyEl) busyEl.classList.remove('is-busy'); }
  }
  async function addToCart(items, btn){
    const label = btn ? btn.innerHTML : '';
    if (btn){ btn.disabled = true; btn.classList.add('is-loading'); }
    try {
      await cartPost((routes.cart_add || '/cart/add') + '.js', {items});
      if (!cartPage) openDrawer('cartDrawer');
      document.dispatchEvent(new CustomEvent('sdj:cart-added'));
    } catch(e){
      alert(e.message || 'Impossible d\'ajouter ce produit au panier.');
    } finally { if (btn){ btn.disabled = false; btn.classList.remove('is-loading'); btn.innerHTML = label; } }
  }
  const changeLine = (key, quantity, trigger) => {
    const row = trigger && trigger.closest('[data-line]');
    if (row){
      /* optimistic UI: update the quantity / fade the row immediately */
      const q = row.querySelector('.qty span'); if (q && quantity > 0) q.textContent = quantity;
      if (quantity === 0) row.classList.add('is-removing');
    }
    return cartPost((routes.cart_change || '/cart/change') + '.js', {id:key, quantity}, quantity === 0 ? null : row)
      .catch(e => { if (row) row.classList.remove('is-removing'); alert(e.message); });
  };
  const applyDiscount = code => cartPost((routes.cart_update || '/cart/update') + '.js', {discount:code});
  SDJ.addToCart = addToCart; SDJ.applyDiscount = applyDiscount;

  /* ---------- Global click handling ---------- */
  document.addEventListener('click', e => {
    if (e.target.closest('.card__qa')) e.preventDefault(); /* option panel inside a product card link */
    const add = e.target.closest('[data-add]');
    if (add){ e.preventDefault(); addToCart([{id:Number(add.dataset.add), quantity:1}], add); return; }
    const line = e.target.closest('[data-line-key]');
    if (line){ e.preventDefault(); changeLine(line.dataset.lineKey, Math.max(0, Number(line.dataset.qty)), line); return; }
    /* quick add with variants (Complétez votre style, drawer upsell) */
    const qaT = e.target.closest('[data-qa-toggle]');
    if (qaT){
      e.preventDefault();
      const qa = qaT.closest('[data-qa]'), panel = qa.querySelector('[data-qa-panel]'), open = panel.hidden;
      $$('[data-qa].is-open').forEach(o => { if (o !== qa){ o.classList.remove('is-open'); o.querySelector('[data-qa-panel]').hidden = true; const t = o.querySelector('[data-qa-toggle]'); t && t.setAttribute('aria-expanded','false'); } });
      panel.hidden = !open; qa.classList.toggle('is-open', open); qaT.setAttribute('aria-expanded', String(open));
      return;
    }
    const qaC = e.target.closest('[data-qa-variant]');
    if (qaC){
      e.preventDefault();
      const qa = qaC.closest('[data-qa]');
      qa.querySelectorAll('[data-qa-variant]').forEach(c => c.setAttribute('aria-checked', String(c === qaC)));
      const pr = qa.querySelector('[data-qa-price]'), cm = qa.querySelector('[data-qa-compare]'), add = qa.querySelector('[data-qa-add]');
      if (pr) pr.textContent = qaC.dataset.qaP || '';
      if (cm){ cm.textContent = qaC.dataset.qaC || ''; cm.hidden = !qaC.dataset.qaC; }
      if (add){ add.dataset.qaAdd = qaC.dataset.qaVariant; add.disabled = false; }
      const sel = qa.querySelector('[data-qa-sel]'); if (sel) sel.textContent = qaC.dataset.qaTitle || '';
      const qi = qa.querySelector('.qa__img img'); if (qi && qaC.dataset.qaImg){ qi.src = qaC.dataset.qaImg; qi.removeAttribute('srcset'); }
      return;
    }
    const qaA = e.target.closest('[data-qa-add]');
    if (qaA){ e.preventDefault(); addToCart([{id:Number(qaA.dataset.qaAdd), quantity:1}], qaA); return; }
    const rmDisc = e.target.closest('[data-discount-remove]');
    if (rmDisc){ e.preventDefault(); store.set('sdj-promo', null); applyDiscount('').catch(() => {}); return; }
    const op = e.target.closest('[data-open]');
    if (op){ e.preventDefault(); openDrawer(op.dataset.open); return; }
    if (e.target.closest('[data-close]') || e.target === overlay) closeDrawers();
    const copy = e.target.closest('[data-copy]');
    if (copy){ navigator.clipboard && navigator.clipboard.writeText(copy.dataset.copy); const o = copy.textContent; copy.textContent = 'Copié ✓'; setTimeout(() => copy.textContent = o, 1600); }
  });
  document.addEventListener('submit', e => {
    const f = e.target;
    /* safety net: any add-to-cart form goes to the drawer, never to /cart */
    if (!e.defaultPrevented && f.matches('form[action*="/cart/add"]')){
      e.preventDefault();
      const fd = new FormData(f), id = Number(fd.get('id'));
      if (id) addToCart([{id, quantity: Math.max(1, parseInt(fd.get('quantity'), 10) || 1)}], f.querySelector('[type="submit"]'));
      return;
    }
    if (f.matches('[data-promo-form]')){
      e.preventDefault();
      const input = f.querySelector('input[name="discount"]') || document.querySelector('input[name="discount"][form="' + f.id + '"]');
      const code = (input.value || '').trim();
      if (!code) return;
      applyDiscount(code).then(() => store.set('sdj-promo', code.toUpperCase())).catch(err => alert(err.message));
    }
  });
  document.addEventListener('keydown', e => {
    if (e.key === 'Escape'){ closePanels(); closeDrawers(); closePromo(); }
    if (e.key === '/' && !/input|textarea|select/i.test(document.activeElement.tagName) && searchBtn){ e.preventDefault(); if (!search.classList.contains('is-open')) searchBtn.click(); }
  });
  /* cart note: save on change */
  document.addEventListener('change', e => {
    if (e.target.matches('[data-cart-note]')) fetch((routes.cart_update || '/cart/update') + '.js', {method:'POST', headers:{'Content-Type':'application/json'}, body:JSON.stringify({note:e.target.value})});
  });

  /* ======================================================================
     PRODUCT PAGE
     ====================================================================== */
  $$('[data-product-section]').forEach(section => {
    const jsonEl = $('[data-product-json]', section);
    if (!jsonEl) return;
    const product = JSON.parse(jsonEl.textContent);
    const invEl = $('[data-inventory-json]', section);
    let invMap = {}; try { invMap = invEl ? JSON.parse(invEl.textContent) : {}; } catch(err){}
    const form = $('form.buy', section);
    const idInput = form && form.querySelector('input[name="id"]');
    const qty = $('[data-qty-input]', section);
    const main = $('.gallery__main img', section);
    const thumbs = $$('[data-thumb]', section);
    const fixed = $('#fixedAtc');
    const selected = () => $$('[data-option-index]', section).map(group => { const c = group.querySelector('[aria-checked="true"]'); return c ? c.dataset.value : null; });

    function showMedia(src, mediaId){
      if (!main || !src) return;
      main.style.opacity = 0;
      setTimeout(() => { main.src = sized(src, 1400); main.srcset = ''; main.style.opacity = 1; }, 150);
      thumbs.forEach(t => t.setAttribute('aria-current', String(mediaId ? t.dataset.mediaId === String(mediaId) : t.dataset.src === src)));
    }
    thumbs.forEach(t => t.addEventListener('click', () => showMedia(t.dataset.src, t.dataset.mediaId)));
    /* mobile swipe gallery */
    const slides = $('[data-slides]', section), dots = $$('[data-dot]', section);
    if (slides){
      let raf = 0;
      slides.addEventListener('scroll', () => { cancelAnimationFrame(raf); raf = requestAnimationFrame(() => {
        const i = Math.round(slides.scrollLeft / Math.max(1, slides.clientWidth));
        dots.forEach((d, j) => d.classList.toggle('is-active', i === j));
      }); }, {passive:true});
    }
    const slideTo = mediaId => {
      if (!slides || !slides.offsetParent || !mediaId) return;
      const el = slides.querySelector('[data-media-id="' + mediaId + '"]');
      if (el) slides.scrollTo({left: el.offsetLeft - slides.offsetLeft, behavior:'smooth'});
    };

    let firstUpdate = true;
    function update(){
      const sel = selected();
      const v = product.variants.find(x => x.options.every((o, i) => sel[i] == null || o === sel[i])) || product.variants[0];
      if (idInput) idInput.value = v.id;
      $$('[data-option-index]', section).forEach(group => {
        const idx = Number(group.dataset.optionIndex);
        const label = $('[data-option-label="'+idx+'"]', section); if (label) label.textContent = sel[idx] || '';
        group.querySelectorAll('[data-value]').forEach(b => {
          const ok = product.variants.some(x => x.available && x.options[idx] === b.dataset.value && x.options.every((o, i) => i === idx || sel[i] == null || o === sel[i]));
          b.classList.toggle('is-unavailable', !ok);
        });
      });
      $$('[data-price]').forEach(el => el.textContent = formatMoney(v.price));
      $$('[data-compare]').forEach(el => { el.textContent = v.compare_at_price > v.price ? formatMoney(v.compare_at_price) : ''; el.hidden = !(v.compare_at_price > v.price); });
      $$('[data-save-badge]').forEach(el => { const on = v.compare_at_price > v.price; el.hidden = !on; if (on){ const pct = Math.round((1 - v.price / v.compare_at_price) * 100); el.dataset.salePct = pct; el.textContent = window.sdjSaleLabel ? window.sdjSaleLabel(pct, el.dataset.g) : 'Economisez ' + pct + '%'; } });
      const inv = $('[data-inventory]', section);
      if (inv){
        const q = invMap[v.id], low = v.available && q != null && q > 0 && q < (Number(inv.dataset.threshold) || 10);
        const date = shipDate(Number(inv.dataset.days) || 0, inv.dataset.skipWe === 'true');
        inv.classList.toggle('is-out', !v.available); inv.classList.toggle('is-low', low);
        const t = inv.querySelector('span');
        if (t) t.textContent = !v.available ? 'Épuisé pour le moment' : (low ? inv.dataset.lowTpl : inv.dataset.inTpl).replace('[date]', date);
      }
      const fsEl = $('[data-fs]', section);
      if (fsEl){
        const fs = Number(fsEl.dataset.fs), ok = v.price >= fs, m = c => formatMoney(c).replace(/[.,]00(?!\d)/, '');
        const fill = t => (t || '').replace('[seuil]', m(fs)).replace('[reste]', m(Math.max(0, fs - v.price)));
        const tt = fsEl.querySelector('[data-fs-title]'), tx = fsEl.querySelector('[data-fs-text]');
        if (tt) tt.textContent = ok ? fsEl.dataset.okTitle : fill(fsEl.dataset.koTitle);
        if (tx) tx.textContent = ok ? fsEl.dataset.okText : fill(fsEl.dataset.koText);
      }
      $$('[data-atc]').forEach(b => { b.disabled = !v.available; b.textContent = v.available ? (b.dataset.label || 'Ajouter au panier') : 'Épuisé'; });
      $$('[data-variant-title]').forEach(el => el.textContent = v.title === 'Default Title' ? '' : v.title);
      if (v.featured_media){
        const src = v.featured_media.preview_image ? v.featured_media.preview_image.src : (v.featured_image && v.featured_image.src);
        if (!(firstUpdate && main && main.dataset.mediaId === String(v.featured_media.id))) showMedia(src, v.featured_media.id);
        slideTo(v.featured_media.id);
        const fi = $('#fixedImg'); if (fi && src) fi.src = sized(src, 120);
      }
      if (history.replaceState && product.variants.length > 1){ const u = new URL(location.href); u.searchParams.set('variant', v.id); history.replaceState({}, '', u); }
      firstUpdate = false;
    }
    $$('[data-option-index]', section).forEach(group => group.addEventListener('click', e => {
      const b = e.target.closest('[data-value]'); if (!b) return;
      group.querySelectorAll('[data-value]').forEach(x => x.setAttribute('aria-checked', String(x === b)));
      update();
    }));
    $$('[data-qty-step]', section).forEach(b => b.addEventListener('click', () => { qty.value = Math.max(1, (parseInt(qty.value, 10) || 1) + Number(b.dataset.qtyStep)); }));
    form && form.addEventListener('submit', e => {
      e.preventDefault();
      addToCart([{id:Number(idInput.value), quantity:Math.max(1, parseInt(qty && qty.value, 10) || 1)}], form.querySelector('[data-atc]'));
    });
    const fixedBtn = $('#fixedAtcBtn');
    fixedBtn && fixedBtn.addEventListener('click', () => addToCart([{id:Number(idInput.value), quantity:1}], fixedBtn));
    if (fixed && form){
      document.body.classList.add('has-fixed-atc');
      /* show once the main button has scrolled out of view; re-check after the drawer or popup closes */
      let pastForm = false;
      const syncFixed = () => fixed.classList.toggle('is-visible', pastForm && !document.body.classList.contains('is-locked'));
      new IntersectionObserver(([en]) => { pastForm = !en.isIntersecting && en.boundingClientRect.top < 0; syncFixed(); }).observe(form);
      new MutationObserver(syncFixed).observe(document.body, {attributes:true, attributeFilter:['class']});
    }
    update();
  });

  /* ======================================================================
     COLLECTION / SEARCH FACETS — Shopify storefront filtering (URL params)
     ====================================================================== */
  function submitFacets(form){
    const params = new URLSearchParams();
    for (const [k, v] of new FormData(form)) if (String(v).trim() !== '') params.append(k, v);
    const sort = $('#sortSelect'); if (sort && sort.value) params.set('sort_by', sort.value);
    const q = form.dataset.query; if (q) params.set('q', q);
    if (form.dataset.type) params.set('type', form.dataset.type);
    document.body.classList.add('is-loading');
    location.href = form.action.split('?')[0] + (params.toString() ? '?' + params : '');
  }
  $$('[data-facets-form]').forEach(f => {
    f.addEventListener('change', e => { if (!e.target.matches('[data-price-input]')) submitFacets(f); });
    f.addEventListener('submit', e => { e.preventDefault(); submitFacets(f); });
    $$('[data-price-input]', f).forEach(i => i.addEventListener('change', () => submitFacets(f)));
  });
  const sortSel = $('#sortSelect');
  sortSel && sortSel.addEventListener('change', () => {
    const f = $('[data-facets-form]');
    if (f) submitFacets(f); else { const u = new URL(location.href); u.searchParams.set('sort_by', sortSel.value); location.href = u; }
  });

  /* ---------- Tabs ---------- */
  $$('[data-tabs]').forEach(tabs => {
    const btns = $$('button[data-tab]', tabs);
    btns.forEach(b => b.addEventListener('click', () => {
      btns.forEach(x => x.setAttribute('aria-selected', String(x === b)));
      $$('[data-tab-panel]', tabs.parentElement).forEach(p => p.hidden = p.dataset.tabPanel !== b.dataset.tab);
    }));
  });

  /* ---------- Account sections ---------- */
  const accNav = $('[data-acc-nav]');
  if (accNav){
    const btns = $$('button[data-acc]', accNav);
    const show = id => { btns.forEach(b => b.setAttribute('aria-selected', String(b.dataset.acc === id))); $$('[data-acc-panel]').forEach(p => p.hidden = p.dataset.accPanel !== id); };
    btns.forEach(b => b.addEventListener('click', () => show(b.dataset.acc)));
    $$('[data-goto-acc]').forEach(a => a.addEventListener('click', e => { e.preventDefault(); show(a.dataset.gotoAcc); window.scrollTo({top:0, behavior:'smooth'}); }));
  }
  /* login ⇄ recover password */
  const toggleRecover = show => { const l = $('#loginBlock'), r = $('#recoverBlock'); if (l && r){ l.hidden = show; r.hidden = !show; } };
  $$('[data-show-recover]').forEach(a => a.addEventListener('click', e => { e.preventDefault(); toggleRecover(true); }));
  $$('[data-hide-recover]').forEach(a => a.addEventListener('click', e => { e.preventDefault(); toggleRecover(false); }));
  if (location.hash === '#recover') toggleRecover(true);
  /* addresses: toggle edit forms */
  $$('[data-toggle-target]').forEach(b => b.addEventListener('click', e => { e.preventDefault(); const t = document.getElementById(b.dataset.toggleTarget); if (t) t.hidden = !t.hidden; }));
  const initProvinces = () => {
    if (!(window.Shopify && Shopify.CountryProvinceSelector)) return;
    $$('[data-address-country]').forEach(sel => {
      const id = sel.id, pid = sel.dataset.provinceId, cid = sel.dataset.containerId;
      try { new Shopify.CountryProvinceSelector(id, pid, {hideElement: cid}); } catch(e){}
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initProvinces); else initProvinces();

  /* ---------- Password show / hide ---------- */
  $$('[data-pw-toggle]').forEach(b => b.addEventListener('click', () => {
    const i = b.parentElement.querySelector('input');
    i.type = i.type === 'password' ? 'text' : 'password';
    b.textContent = i.type === 'password' ? 'Afficher' : 'Masquer';
  }));

  /* ---------- FAQ: search + categories ---------- */
  const faqList = $('#faqList');
  if (faqList){
    const items = $$('.accordion', faqList), titles = $$('.faq-group-title', faqList);
    let cat = 'all';
    const run = () => {
      const q = norm(($('#faqSearch') || {}).value || '');
      let n = 0;
      items.forEach(it => { const ok = (cat === 'all' || it.dataset.cat === cat) && (!q || norm(it.textContent).includes(q)); it.hidden = !ok; if (ok) n++; if (q && ok) it.open = true; });
      titles.forEach(t => t.hidden = !items.some(it => it.dataset.cat === t.dataset.cat && !it.hidden));
      const empty = $('#faqEmpty'); empty && empty.classList.toggle('is-visible', !n);
    };
    $('#faqSearch') && $('#faqSearch').addEventListener('input', run);
    $$('.faq-cats button').forEach(b => b.addEventListener('click', () => { cat = b.dataset.cat; $$('.faq-cats button').forEach(x => x.setAttribute('aria-pressed', String(x === b))); run(); }));
  }

  /* ---------- Footer columns: open on desktop, accordion on mobile ---------- */
  const mq = window.matchMedia('(min-width:900px)');
  const syncFooter = () => $$('[data-footer-col]').forEach(d => d.open = mq.matches);
  syncFooter(); mq.addEventListener('change', syncFooter);
  initCartSticky();

  /* ======================================================================
     WELCOME POPUP — newsletter signup → code applied to the cart
     ====================================================================== */
  const promo = $('#promo'), tab = $('#promoTab');
  const noPopup = document.body.dataset.noPopup !== undefined;
  function openPromo(){
    if (!promo || promo.classList.contains('is-open')) return;
    promo.classList.add('is-open'); promo.setAttribute('aria-hidden','false');
    document.body.classList.add('is-locked');
    tab && tab.classList.remove('is-visible');
    store.set('sdj-promo-seen', Date.now());
  }
  function closePromo(){
    if (!promo || !promo.classList.contains('is-open')) return;
    promo.classList.remove('is-open'); promo.setAttribute('aria-hidden','true');
    if (!$('.drawer.is-open')) document.body.classList.remove('is-locked');
    if (tab && !noPopup && !store.get('sdj-promo-claimed', false)) tab.classList.add('is-visible');
  }
  SDJ.openPromo = openPromo;
  if (promo){
    const code = promo.dataset.code;
    const success = promo.dataset.success === 'true';
    const claimed = store.get('sdj-promo-claimed', false);
    $$('[data-promo-close]').forEach(b => b.addEventListener('click', closePromo));
    tab && tab.addEventListener('click', openPromo);
    if (success || promo.classList.contains('is-done')){
      /* returned from Shopify's newsletter form: show the code and apply it */
      store.set('sdj-promo-claimed', true);
      promo.classList.add('is-done');
      openPromo();
      if (code){ store.set('sdj-promo', code); applyDiscount(code).catch(() => {}); }
    } else if (promo.dataset.hasErrors === 'true'){
      openPromo();
    } else if (!noPopup && !claimed && !window.Shopify?.designMode){
      const delay = (Number(promo.dataset.delay) || 6) * 1000;
      const due = Date.now() - store.get('sdj-promo-seen', 0) > (Number(promo.dataset.frequency) || 7) * 864e5;
      if (due){
        const t = setTimeout(openPromo, delay);
        document.addEventListener('mouseout', function exit(ev){ if (!ev.relatedTarget && ev.clientY < 10){ clearTimeout(t); openPromo(); document.removeEventListener('mouseout', exit); } });
      } else if (tab) tab.classList.add('is-visible');
    }
    /* theme editor: open when the section is selected */
    document.addEventListener('shopify:section:select', ev => { if (promo.closest('.shopify-section') && ev.target.contains(promo)) openPromo(); });
    document.addEventListener('shopify:section:deselect', ev => { if (ev.target.contains(promo)) closePromo(); });
  }
  /* footer newsletter success → apply code too */
  if ($('[data-newsletter-success]') && promo && promo.dataset.code){
    store.set('sdj-promo-claimed', true); store.set('sdj-promo', promo.dataset.code);
    applyDiscount(promo.dataset.code).catch(() => {});
  }

  /* ---------- Product cards: hover photo loads on first hover, never on touch screens ---------- */
  if (window.matchMedia('(hover:hover)').matches){
    document.addEventListener('pointerover', e => {
      if (e.pointerType === 'touch' || !e.target.closest) return;
      const card = e.target.closest('.card'), media = card && card.querySelector('.card__media[data-second]');
      if (!media) return;
      const first = media.querySelector('img'), src = media.dataset.second;
      media.removeAttribute('data-second');
      if (!first) return;
      const img = new Image();
      img.className = 'second'; img.alt = '';
      img.onload = () => { img.style.opacity = 0; first.after(img); requestAnimationFrame(() => requestAnimationFrame(() => img.style.removeProperty('opacity'))); };
      img.src = src;
    }, {passive:true});
  }
})();
